
import { createClient } from '@supabase/supabase-js';
import { DEMO_DATA } from '../demo/demoData';
import { createDemoQueryBuilder, createDemoWriteBuilder } from '../demo/demoQueryBuilder';

export const supabaseUrl = 'https://vzzlqhhpuxmqmwhbrmpv.supabase.co';
export const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ6emxxaGhwdXhtcW13aGJybXB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAyODkzODMsImV4cCI6MjA4NTg2NTM4M30.X30UCKEljioCUl2aDOr43GgdojL66iSVJ8EZgOWB3kQ';

// Echter Client — wird für Auth, Storage, Channel und Demo-Status immer verwendet
export const supabaseReal = createClient(supabaseUrl, supabaseAnonKey);

// ─── Demo-Mode Flag ───────────────────────────────────────────────────────────
// Sofort aus localStorage lesen, BEVOR React rendert — verhindert Race Conditions
let _demoMode = (() => {
  try {
    return localStorage.getItem('immo_demo_mode') === 'true';
  } catch {
    return false;
  }
})();

export function setDemoMode(active: boolean) {
  _demoMode = active;
}

export function isDemoMode(): boolean {
  return _demoMode;
}

// ─── Demo Storage Proxy ──────────────────────────────────────────────────────
// Fängt Storage-Operationen ab und gibt leere/simulierte Ergebnisse zurück.

function createDemoStorageBucket() {
  return {
    upload: () => Promise.resolve({ data: { path: 'demo/placeholder.jpg' }, error: null }),
    remove: () => Promise.resolve({ data: [], error: null }),
    createSignedUrl: (_path: string, _expiresIn: number) =>
      Promise.resolve({ data: { signedUrl: '' }, error: { message: 'Demo-Modus: Dateien nicht verfügbar' } }),
    getPublicUrl: (_path: string) => ({ data: { publicUrl: '' } }),
    download: () => Promise.resolve({ data: null, error: { message: 'Demo-Modus: Download nicht verfügbar' } }),
    list: () => Promise.resolve({ data: [], error: null }),
  };
}

const demoStorageProxy = {
  from: () => createDemoStorageBucket(),
};

// ─── Proxy ────────────────────────────────────────────────────────────────────
// Fängt .from(), .rpc() und .storage ab wenn Demo-Modus aktiv.
// Auth und Channel gehen immer an den echten Client.

export const supabase = new Proxy(supabaseReal, {
  get(target, prop: string) {
    if (!_demoMode) return (target as any)[prop];

    // .from() → Demo-Daten
    if (prop === 'from') {
      return (tableName: string) => ({
        select: (...args: any[]) => createDemoQueryBuilder(tableName, DEMO_DATA).select(...args),
        insert: (_data?: any) => createDemoWriteBuilder(_data),
        update: (_data?: any) => createDemoWriteBuilder(_data),
        delete: () => createDemoWriteBuilder(),
        upsert: (_data?: any) => createDemoWriteBuilder(_data),
      });
    }

    // .rpc() → Simulierte Erfolgs-Antwort
    if (prop === 'rpc') {
      return (_fnName: string, _params?: any) =>
        Promise.resolve({ data: null, error: null });
    }

    // .storage → Demo-Storage-Proxy
    if (prop === 'storage') {
      return demoStorageProxy;
    }

    // Auth, Channel, etc. → immer an echten Client
    return (target as any)[prop];
  },
});
